import {countryArr} from "@/assets/js/country";
import {nationArr} from "@/assets/js/nation";
import {languageArr} from "@/assets/js/language";
import {info_view} from "@/api/training_student/vita";
import {storageData} from "@/assets/js/storage";
const HOST = process.env.VUE_APP_URL;
export default {
    data() {
        const gender = [
            {
                key: "男",
                val: "Male"
            },
            {
                key: "女",
                val: "Female"
            },
        ];
        return {
            gender,
            countryArr,
            nationArr,
            languageArr,
            stuInfo: {},
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            info_view({})
                .then(({data}) => {
                    if (Number(data.status) === 0) {
                        // console.log(data);
                        let {language_list, academic_data, experience_data, playing_data, studentSingnInfo,auditData} = data.result;
                        // 护照头像，身份证正反面
                        // 1.判断是否是未完善
                        const userInfo = storageData.getUserInfo();
                        this.memberType=userInfo.member_type;
                        if (studentSingnInfo.student_information==='verify'){
                            this.not_allow_change=false
                        }else{
                            // 2.判断用户身份,到期学员只有在拒绝才可以改
                            if (userInfo.member_type==="expireStudent" && (!studentSingnInfo.info_status ||studentSingnInfo.info_status==='refused') ){
                                this.not_allow_change=false
                            }else if (userInfo.member_type==="student"  ){
                                this.not_allow_change=false
                            }
                        }
                        studentSingnInfo.profile_picture && (this.photo = HOST + studentSingnInfo.profile_picture);
                        if (studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
                            this.$set(this.vitaForm,'family_name_spell',studentSingnInfo.family_name_spell);
                            this.switch_pinyin=true;
                        }
                        if(studentSingnInfo.family_name_spell && studentSingnInfo.given_name_spell){
                            this.spell_both=true;
                        }
                        if(studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
                            this.spell_family=true;
                        }
                        if(!studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell){
                            this.spell_none=true;
                        }
                        this.id_type=studentSingnInfo.id_type
                        if (auditData.length>0)this.auditData=auditData;
                        if (studentSingnInfo.student_information ==='Active'){
                            this.showMyResume=true;
                        }
                        studentSingnInfo.id_card_photo_front && (this.cardFront = HOST + studentSingnInfo.id_card_photo_front);
                        studentSingnInfo.id_card_photo_verso && (this.cardBack = HOST + studentSingnInfo.id_card_photo_verso);
                        // 外语
                        language_list.length && this.$set(this.vitaForm, "language_row", language_list);
                        // 公用临时数组
                        let tempArr = [];
                        // 教育经历
                        let academic_qualification = [];
                        if (academic_data.length) {
                            academic_qualification = academic_data.map((item) => {
                                if(item.academic_start_date && item.academic_end_date) {
                                    tempArr = [new Date(item.academic_start_date), new Date(item.academic_end_date)];
                                } else {
                                    tempArr = [];
                                }
                                return {
                                    ...item,
                                    time: tempArr,
                                };
                            });
                        }
                        // 执教经历
                        let coaching_Experience = [];
                        if (experience_data.length) {
                            coaching_Experience = experience_data.map((item) => {
                                if(item.coach_start_date && item.coach_end_date) {
                                    tempArr = [new Date(item.coach_start_date), new Date(item.coach_end_date)];
                                } else {
                                    tempArr = [];
                                }
                                return {
                                    ...item,
                                    time: tempArr,
                                };
                            });
                        }
                        // 运动经历
                        let playing_experience = [];
                        if (playing_data.length) {
                            playing_experience = playing_data.map((item) => {
                                if(item.play_start_date && item.play_end_date) {
                                    tempArr = [new Date(item.play_start_date), new Date(item.play_end_date)];
                                } else {
                                    tempArr = [];
                                }
                                return {
                                    ...item,
                                    time: tempArr,
                                };
                            });
                        }
                        let mixinObj = {
                            academic_qualification,
                            // coaching_qualification,
                            coaching_Experience,
                            playing_experience
                        };
                        let {entries} = Object;
                        for (let [key, value] of entries(mixinObj)) {
                            if (value.length === 0) {
                                delete mixinObj[key];
                            }
                        }
                        // 学员信息
                        // const birthDay = studentSingnInfo.id_number.length == 18
                        //     ? studentSingnInfo.id_number.substr(6, 4) + "-" + studentSingnInfo.id_number.substr(10, 2) + "-" + studentSingnInfo.id_number.substr(12, 2)
                        //     : "--";
                            // (!birthDay) && (this.canChangeBirthday = true)
                        const birthDay = studentSingnInfo.birthday
                        // console.log(birthDay)
                        if(!birthDay){this.canChangeBirthday=true}
                        this.noEdit = {
                            gender: studentSingnInfo.gender,
                            phone: studentSingnInfo.mobile_phone,
                            idNum: studentSingnInfo.id_number,
                            birthDay,
                        };
                        let gender = studentSingnInfo.gender
                        if (studentSingnInfo.student_information ==='verify'){
                            studentSingnInfo.id_type !=='id_number'  &&  (gender = '')
                        }
                        this.vitaForm = {
                            ...this.vitaForm,
                            birthday:birthDay ? birthDay : '',
                            ...studentSingnInfo,
                            ...mixinObj,
                            gender
                        };
                        this.isLoading = false;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
    }
}
